<template>
  <div>
    <h4>Fruta</h4>
    <b-table small bordered fixed hover :items="items" :fields="fields">
      <template v-slot:cell(actions)="row">
        <div class="text-right">
          <a href="#" @click.prevent="createContent(row.item)" class="text-primary"
            ><i class="fa fa-plus fa-lg mx-1"></i
          ></a>
          <a href="#" @click.prevent="editLot(row.item)" class="text-primary"
            ><i class="fa fa-pencil fa-lg mx-1"></i
          ></a>
          <a href="#" @click.prevent="areYouSure(row.item.id, 'lot')" class="text-danger"
            ><i class="fa fa-trash fa-lg mx-1" style="color: red"></i
          ></a>
        </div>
      </template>

      <template slot="row-details" slot-scope="row">
        <b-table :items="row.item.content_set" :fields="details_fields" foot-clone small>
          <template v-slot:foot()> <span></span> </template>
          <template v-slot:cell(detail_actions)="detail_row">
            <a
              v-if="user.ID_CLIENTE != 4"
              href="#"
              @click.prevent="editContent(detail_row.item)"
              class="text-primary mx-1"
              ><i class="fa fa-pencil fa-lg mt-1"></i
            ></a>
            <a href="#" @click.prevent="printContent(detail_row.item)" class="text-primary mx-1"
              ><i class="fa fa-print fa-lg mt-1"></i
            ></a>
            <a href="#" @click.prevent="areYouSure(detail_row.item, 'content')" class="text-danger mx-1"
              ><i class="fa fa-close fa-lg mt-1" style="color: red"></i
            ></a>
          </template>
          <template v-slot:cell(string_specs)="detail_row"
            >{{ detail_row.item.string_specs }}
            <div v-for="(field, index) in detail_row.item.custom_fields" :key="index">
              <span v-if="field != null && field != false"> {{ index | labelize }}: {{ field }} </span>
            </div>
          </template>
          <template v-slot:foot(quantity)>{{ arraySum(row.item.content_set, "quantity") }}</template>
          <template v-slot:foot(net_kilograms)>{{ arraySum(row.item.content_set, "net_kilograms") }}</template>
          <template v-slot:foot(gross_kilograms)>{{ arraySum(row.item.content_set, "gross_kilograms") }}</template>
        </b-table>
      </template>
      <template v-slot:cell(pallets)="row">
        <div>
          <p>
            {{ row.item.content_set.length }}
            <a href="#" class="mx-2" @click.prevent="row.toggleDetails"><u>Mostrar pallets</u></a>
          </p>
        </div>
      </template>

      <template slot="status_content" style="text-align: center" slot-scope="row">
        <b-badge variant="info" v-if="row.item.status_content == 1">Sin Procesar </b-badge>
        <b-badge variant="success" v-if="row.item.status_content == 0">Procesado </b-badge>
      </template>
    </b-table>

    <printContent ref="printContent"></printContent>
  </div>
</template>

<script>
import iModal from "./DetalleRecepcionInfoModal.vue";
import { bus } from "../../main";
import VueNotifications from "vue-notifications";
import miniToastr from "mini-toastr";
import Vue from "vue";
import printContent from "../printComponent/printContent.vue";
import { mapState } from "vuex";
import labelize from "@/assets/js/utils";

const toastTypes = {
  success: "success",
  error: "error",
  info: "info",
  warn: "warn"
};

miniToastr.init({ types: toastTypes });

Vue.use(VueNotifications);
Vue.use(miniToastr);

export default {
  name: "c-table",
  inheritAttrs: false,
  components: {
    iModal,
    printContent
  },
  props: {
    waybillID: {},
    caption: {
      type: String,
      default: "Table"
    },
    hover: {
      type: Boolean,
      default: false
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: true
    },
    fixed: {
      type: Boolean,
      default: true
    },
    tableData: {
      type: [Array, Function],
      default: () => []
    },
    fields: {
      type: [Array, Object],
      default: () => [
        { key: "pallet_number", label: "Número" },
        "product_name",
        "product_type_name",
        "variety_name",
        "condition",
        "container.name",
        "string_specs",
        "quantity",
        "net_kilograms",
        "status_content",
        "actions",
        "show_details"
      ]
    },
    perPage: {
      type: Number,
      default: 15
    },
    dark: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      currentPage: 1,
      infoModal: false,
      contentInfo: {},
      content_fields: [
        { key: "pallet_number", label: "Pallet", sorteable: true },
        { key: "container_name", label: "Formato/Recip", sorteable: true },
        { key: "string_specs", label: "Especificaciones", sorteable: true },
        { key: "quantity", label: "Cantidad", sorteable: true },
        { key: "gross_kilograms", label: "Kg Brutos", sorteable: true },
        { key: "net_kilograms", label: "Kg Netos", sorteable: true },
        { key: "actions", label: "Acciones", sorteable: true }
      ],
      details_fields: [
        { key: "pallet_number", label: "Pallet", sorteable: true },
        { key: "container_name", label: "Formato/Recip", sorteable: true },
        { key: "string_specs", label: "Especificaciones", sorteable: true },
        { key: "quantity", label: "Cantidad", sorteable: true },
        { key: "gross_kilograms", label: "Kg Brutos", sorteable: true },
        { key: "net_kilograms", label: "Kg Netos", sorteable: true },
        {
          key: "detail_actions",
          label: "",
          class: "text-right"
        }
      ]
    };
  },
  filters: {
    labelize(value) {
      return labelize(value);
    }
  },
  computed: {
    ...mapState(["user"]),
    items: function () {
      const items = this.tableData;
      return Array.isArray(items) ? items : items();
    },
    totalRows: function () {
      return this.getRowCount();
    },
    captions: function () {
      return this.fields;
    }
  },
  methods: {
    arraySum(arr, field) {
      return arr.reduce((total, obj) => total + parseFloat(obj[field]), 0);
    },
    editLot(data) {
      bus.$emit("lotEdit", data);
    },
    editContent(data) {
      bus.$emit("editContent", data);
    },
    createContent(data) {
      bus.$emit("createContent", data);
    },
    printContent(data) {
      this.$refs.printContent.modalShown = true;
      this.$refs.printContent.contentPrint = data;
    },
    showAlert(item) {
      alert(item);
    },
    getBadge(product_type) {
      return product_type === "Fresco"
        ? "success"
        : product_type === "IQF"
        ? "secondary"
        : product_type === "i"
        ? "warning"
        : product_type === "Banned"
        ? "danger"
        : "primary";
    },
    getRowCount: function () {
      return this.items.length;
    },
    deleteContent(item) {
      if (item.status_content == true) {
        const Data = {
          id_content: item.id,
          id_pallet: item.pallet,
          client: this.$store.getters.user.ID_CLIENTE,
          tipo: 1
        };
        this.$axios
          .delete("/api/v1/content/delete_content/", { data: Data })
          .then((res) => {
            const data = res.data.data;
            miniToastr.success("Operación realizada con éxito", "");
            this.$emit("refreshContent", this.waybillID);
          })
          .catch((error) => console.log(error));
      }
      if (item.status_content == false) {
        miniToastr.info("Imposible eliminar, contenido procesado !!", "");
      }
    },
    areYouSure(item, item_type) {
      this.$swal
        .fire({
          title: "¿Seguro que quiere eliminar esta fila??",
          text: "",
          type: "warning",
          showCancelButton: true,
          cancelButtonText: "No",
          confirmButtonText: "Si"
        })
        .then((result) => {
          if (result.value) {
            switch (item_type) {
              case "lot":
                this.deleteRow(item);
                break;
              case "content":
                this.deleteContent(item);
                break;
              default:
                break;
            }
            this.$swal("File eliminada con éxito");
          } else {
          }
        });
    },
    deleteRow(item) {
      this.$axios
        .delete("/api/v1/lot/" + item + "/")
        .then((res) => {
          const data = res.data.data;
          miniToastr.success("Operación realizada con éxito", "");
          this.$emit("refreshContent", this.waybillID);
        })
        .catch((error) => console.log(error));
    },
    debug(a) {
      alert(JSON.stringify(a));
    }
  }
};
</script>

<style scoped></style>
